import { useTranslation } from "react-i18next";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import CustomDialog from "../modals/CustomDialog/CustomDialog";
import { Button } from "../forms/Buttons/Button";

export default function ExitExamModal({
  isOpen,
  onConfirm,
  onCancel,
  loading = false,
}) {
  const { t } = useTranslation();

  return (
    <CustomDialog
      isOpen={isOpen}
      headerText={t("exam_taking.exit_exam")}
      closeModal={onCancel}
      maxWidth="max-w-lg"
    >
      <div className="flex flex-col gap-6 pt-4">
        <div className="flex items-start gap-4">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-50 ring-1 ring-inset ring-red-100">
            <ExclamationTriangleIcon className="h-5 w-5 text-red-600" aria-hidden="true" />
          </span>
          <div className="min-w-0 pt-0.5">
            <p className="font-medium text-slate-900">
              {t("exam_taking.exit_warning_title")}
            </p>
            <p className="mt-1 text-sm leading-6 text-slate-500">
              {t("exam_taking.exit_warning_description")}
            </p>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-slate-100 pt-5 sm:flex-row sm:justify-end">
          <Button
            text={t("buttons.cancel")}
            color="secondary-outline"
            onClick={onCancel}
            disabled={loading}
          />
          <Button
            text={t("exam_taking.exit_and_submit")}
            color="error"
            onClick={onConfirm}
            loading={loading}
          />
        </div>
      </div>
    </CustomDialog>
  );
}
